export default [{
        path: '/dataList/paperManage',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '纸质套餐类型管理',
            authLogin: true
        }
    },
    // {
    //     path: '/data/paperCard/edit',
    //     component: resolve => require(['../edit.vue'], resolve),
    //     meta: {
    //         title: '新增纸质套餐',
    //         authLogin: true
    //     }
    // },
    // {
    //     path: '/data/paperCard/detail/:id',
    //     component: resolve => require(['../detail.vue'], resolve),
    //     meta: {
    //         title: '消费详情',
    //         authLogin: true
    //     }
    // },
]